import React from "react";
import Question from "../Components/question/Question";
import TopBar from "../Components/common/TopBar";
import Spacer2 from "../Components/common/Spacer2";

function QuestionPage() {
  return (
    <>
      <TopBar />
      <Spacer2 />
      <Question />
    </>
  );
}

export default QuestionPage;
